<template>
  <div id="mediaAndTemplatePage">
    <template v-if="inFilesRoute">
      <media
        :mediaComponentAsProp="mediaComponentAs"
        :isParentComponentMountedProp="isParentComponentMounted">
      </media>
    </template>
    <template v-else>
      <project-audio v-if="pageContent === pageContentOptions.audio"></project-audio>
      <project-template v-if="pageContent === pageContentOptions.newProject"
        :isParentComponentMountedProp="isParentComponentMounted">
      </project-template>
      <template-set v-if="pageContent === pageContentOptions.template"></template-set>
    </template>
  </div>
</template>

<script src="./create.js"></script>
<style lang="scss" src="./create.scss"></style>
